import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProductsProvider } from './context/ProductsContext';
import { CalculatorProvider } from './context/CalculatorContext';
import { ScenarioProvider } from './context/ScenarioContext';
import { TeamProvider } from './context/TeamContext';
import { ToastProvider } from './components/Common/Toast';
import Header from './components/Header/Header';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import PrivateRoute from './components/Auth/PrivateRoute';
import Dashboard from './pages/Dashboard';
import ProductsPage from './pages/ProductsPage';
import ResultsPage from './pages/ResultsPage';
import ScenariosPage from './pages/ScenariosPage';
import HelpPage from './pages/HelpPage';
import TeamHierarchyPage from './pages/TeamHierarchyPage';
import AdminReportsPage from './pages/AdminReportsPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ProductsProvider>
          <CalculatorProvider>
            <ScenarioProvider>
              <TeamProvider>
                <ToastProvider>
                <div className="min-h-screen bg-gray-50">
                  <Header />
                  <main>
                    <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    
                    {/* Protected routes */}
                    <Route
                      path="/dashboard"
                      element={
                        <PrivateRoute>
                          <Dashboard />
                        </PrivateRoute>
                      }
                    />
                    
                    <Route
                      path="/products"
                      element={
                        <PrivateRoute>
                          <ProductsPage />
                        </PrivateRoute>
                      }
                    />
                    
                    <Route
                      path="/results"
                      element={
                        <PrivateRoute>
                          <ResultsPage />
                        </PrivateRoute>
                      }
                    />
                    
                    <Route
                      path="/scenarios"
                      element={
                        <PrivateRoute>
                          <ScenariosPage />
                        </PrivateRoute>
                      }
                    />
                    
                    <Route
                      path="/help"
                      element={
                        <PrivateRoute>
                          <HelpPage />
                        </PrivateRoute>
                      }
                    />
                    
                    <Route
                      path="/teams"
                      element={
                        <PrivateRoute>
                          <TeamHierarchyPage />
                        </PrivateRoute>
                      }
                    />
                    
                    {/* Hidden admin route - no navigation link, direct URL access only */}
                    <Route
                      path="/sys/reports"
                      element={
                        <PrivateRoute>
                          <AdminReportsPage />
                        </PrivateRoute>
                      }
                    />
                    
                    {/* Default redirect */}
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                  </Routes>
                  </main>
                </div>
                </ToastProvider>
              </TeamProvider>
            </ScenarioProvider>
          </CalculatorProvider>
        </ProductsProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
